// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"353":"28fa6487","828":"707a3fe2"}[chunkId] + ".js";
};